import * as $ from "jquery";
import "block-ui";
import "bootstrap";
import "bootstrap-datepicker";
import "bootstrap-datepicker/js/locales/bootstrap-datepicker.ja";
import * as bootbox from "bootbox";
import { url } from "./util"

$(() => {
    $(".date").datepicker({
        autoclose: true,
        language: "ja",
        startDate: "2000/01/01",
        endDate: "2099/12/31"
    });

    $(".month").datepicker({
        format: 'yyyy/mm',
        autoclose: true,
        language: "ja",
        startDate: "2000/01",
        endDate: "2099/12",
        minViewMode: 'months'
    });

    $(document).on("click", ".confirm", (event) => {
        bootbox.confirm($(event.currentTarget).data("message"), (isOk) => {
            if (!isOk) {
                return;
            }

            setTimeout(() => {
                $(event.currentTarget).removeClass("confirm");
                $(event.currentTarget).click();
            }, 300);
        });

        return false;
    });

    $.ajaxPrefilter((options, originalOptions, jqXHR) => {
        const token = $("meta[name='_csrf']").attr("content");
        const header = $("meta[name='_csrf_header']").attr("content");
        jqXHR.setRequestHeader(header, token);
    });

    $("form").submit(() => {
        $("input").prop("disabled", false);
        $("select").prop("disabled", false);
        $("textarea").prop("disabled", false);
    });

    $("form.block").submit((event) => {
        $.blockUI({
            message: `<img src="${url('/images/loading.svg')}"/>`,
            css: {
                backgroundColor: "none",
                border: "none"
            }
        });
    });
});